import { handleActions } from "redux-actions";
import {
  getRangeOptions,
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  SET_CHART_LOADING,
  UPDATE_FILTERS,
  UPDATE_CUSTOM_RANGE,
  FETCH_FILTER_SUCCESS,
  FETCH_CHART_SUCCESS,
  UPDATE_TABLE_VIEW_SELECTED,
  RESET_FILTERS_SELECTED,
  FETCH_CURRENT_USER_SUCCESS,
  SET_ALL_SITES_MODE
} from "./activitiesSaga";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  isLoading: true,
  isAllSitesMode: false,
  areChartsLoading: false,
  filtersDirty: false,
  chartDirty: false,
  filters: {},
  chartsData: {
    tableData: {
      isLoading: false,
      content: {}
    },
    lineChartData: {
      isLoading: false,
      content: {}
    }
  },
  selectedRangeOption: {},
  selectedFilters: {
    table_view: false
  },
  rangeOptions: []
};

export default handleActions(
  {
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      areChartsLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [UPDATE_FILTERS]: (state, action) => ({
      ...state,
      selectedFilters: action.payload,
      filtersDirty: true
    }),
    [RESET_FILTERS_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...state.selectedFilters,
        startDate: state.filters.startDate,
        endDate: state.filters.endDate,
        staffs: state.filters.staffs
      }
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_ALL_SITES_MODE]: (state, action) => ({
      ...state,
      isAllSitesMode: action.payload
    }),
    [SET_CHART_LOADING]: (state, action) => ({
      ...state,
      isChartLoading: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        action.payload.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      selectedFilters: { ...state.selectedFilters, ...action.payload },
      chartDirty: true,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload.data,
      selectedRequestDates: getDateRanges(
        action.payload.calendarEndDate,
        action.payload.data,
        action.payload.calendarStartDate
      ),
      selectedFilters: {
        ...state.selectedFilters
      },
      filtersDirty: true,
      chartDirty: true
    }),
    [FETCH_FILTER_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
      selectedFilters: {
        ...state.selectedFilters,
        staffs: action.payload.staffs
      }
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartsData: {
        ...state.chartsData,
        ...action.payload
      }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      },
      chartDirty: false
    }),
    [UPDATE_FILTERS]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload
      },
      filtersDirty: true,
      chartDirty: true
    })
  },
  initialState
);
